import { List } from "antd";
import Moment from "react-moment";
import { TableEditDeleteIcons } from "top-component-library";
import SelectInput from "top-component-library/form-inputs/SelectInput";
import { isSnoozed } from "util/Utils";

import {
  ALERT_LABELS,
  CATERING_UNOPENED_HOURS_OPTIONS,
  EMAIL_DUE_OPTIONS,
  ORDER_UNOPENED_MINUTES_OPTIONS,
} from "../supportAlertConstants";
import { AlertCardContainer, StationInput } from "./styles";

// A single custom alert in the builder: its trigger-time control (which varies by alert type)
// and the stations it applies to.
const AlertCard = ({ alert, index, possibleStations, onChangeOption, onRemove }) => {
  const alertType = alert.alert_class;
  return (
    <List.Item>
      <AlertCardContainer
        title={ALERT_LABELS[alertType]}
        extra={<TableEditDeleteIcons onDelete={() => onRemove(index)} />}
      >
        {isSnoozed(alert.snooze_till_time) && (
          <div>
            Snoozed until <Moment fromNow>{alert.snooze_till_time}</Moment>
          </div>
        )}
        {alertType === "catering_order_unopened" && (
          <div>
            <div>Alert Trigger Time</div>
            <SelectInput
              id={`alert-${index}-option`}
              options={CATERING_UNOPENED_HOURS_OPTIONS}
              defaultValue={alert.hours}
              onChange={(val) => onChangeOption(alert, index, { hours: val })}
            />
          </div>
        )}
        {alertType === "email_catering_order_in" && (
          <div>
            <div>Alert Trigger Time</div>
            <SelectInput
              id={`alert-${index}-option`}
              options={EMAIL_DUE_OPTIONS}
              defaultValue={
                alert.timePicker === "hours" ? alert.hours + alert.timePicker : alert.minutes + alert.timePicker
              }
              onChange={(val) =>
                onChangeOption(
                  alert,
                  index,
                  val === "4hours"
                    ? { hours: "4", minutes: null, timePicker: "hours" }
                    : { hours: null, minutes: "30", timePicker: "minutes" }
                )
              }
            />
          </div>
        )}
        {alertType === "order_unopened" && (
          <div>
            <div>Alert Trigger Time</div>
            <SelectInput
              id={`alert-${index}-option`}
              options={ORDER_UNOPENED_MINUTES_OPTIONS}
              defaultValue={alert.minutes}
              onChange={(val) => onChangeOption(alert, index, { minutes: val })}
            />
          </div>
        )}
        <div>Stations Affected</div>
        <StationInput
          id={`alert-${index}-stations`}
          options={possibleStations.map((station) => ({ label: station.station_name, value: station.id }))}
          defaultValue={alert.stationSetting === "all" ? ["All Stations"] : alert.stations.map((station) => station.id)}
          onChange={(val) => {
            onChangeOption(
              alert,
              index,
              val.includes("All Stations")
                ? { stations: [], stationSetting: "all" }
                : { stations: val.map((stationId) => possibleStations.find((station) => stationId === station.id)) }
            );
          }}
          multiSelect
        />
      </AlertCardContainer>
    </List.Item>
  );
};

export default AlertCard;
